import script from "./ViewRatingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewRatingPage.vue?vue&type=script&setup=true&lang=ts"

import "./ViewRatingPage.vue?vue&type=style&index=0&id=be9e3726&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be9e3726"]])

export default __exports__